/**
 * Product tour steps use [data-tour="..."] targets on the live dashboard layout.
 * Order is top-to-bottom / chronological for first-time users.
 */
export const dashboardTour = [
  {
    target: '[data-tour="dashboard-dri-hero"]',
    title: 'DRI Score™',
    content:
      'Your Driver Readiness Index summarizes document completeness, vehicle readiness, and authority standing. Open Analytics for the full weighted breakdown.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="dashboard-pillar-docs"]',
    title: 'Document Health',
    content: 'Track how complete your compliance file is and upload missing documents in one tap.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="dashboard-pillar-vehicles"]',
    title: 'Vehicle Readiness™',
    content: 'Fleet readiness and inspections at a glance—jump to Vehicles to fix issues.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="dashboard-pillar-authority"]',
    title: 'Authority Health',
    content: 'DOT authority, MCS-150, and UCR status—keep your operating authority in good standing.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="dashboard-quick-actions"]',
    title: 'Quick actions',
    content:
      'Upload documents, add vehicles, update insurance, or run clearinghouse checks—one click from here. Use the sidebar for IFTA, Timeline, and more.',
    placement: 'top',
  },
];

export const documentsTour = [
  {
    target: '.upload-section',
    content: 'Start by uploading your compliance documents. We support medical cards, insurance, vehicle registrations, and more.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.document-type-selector',
    content: 'Select the document type so we can track expiration dates and send timely reminders.',
    placement: 'right',
  },
  {
    target: '.expiring-documents-widget',
    content: 'Documents expiring soon appear here. Never miss a deadline!',
    placement: 'left',
  },
];

export const vehiclesTour = [
  {
    target: '.add-vehicle-button',
    content: 'Add your vehicles to track inspections, maintenance, and compliance.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.vehicle-list',
    content: 'Each vehicle shows its compliance status and inspection history.',
    placement: 'top',
  },
  {
    target: '.dvir-button',
    content: 'Log daily DVIRs (Driver Vehicle Inspection Reports) to stay DOT compliant.',
    placement: 'left',
  },
];

export const iftaTour = [
  {
    target: '.log-trip-button',
    content: 'Log each trip to track mileage by state for IFTA quarterly reporting.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.ifta-stats-grid',
    content: 'See your quarter summary: total miles, trips, states traveled, and fuel purchased.',
    placement: 'bottom',
  },
  {
    target: '.state-breakdown-table',
    content: 'This breakdown shows miles and fuel by state - exactly what you need for IFTA filing.',
    placement: 'top',
  },
  {
    target: '.export-csv-button',
    content: 'Export your quarterly report to CSV and send it to your accountant. Easy!',
    placement: 'left',
  },
];

export const authorityTour = [
  {
    target: '.dot-lookup-section',
    content: 'Enter your DOT number to pull your authority information from FMCSA.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.save-authority-button',
    content: 'Save your authority to track MCS-150 updates and UCR registration.',
    placement: 'top',
  },
];
